import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PharmacyService } from '../../../../services/pharmacy/pharmacy.service';
import { PharmacyVTO } from '../../../../services/pharmacy/pharmacy.model';
import { EditPharmacyForm } from '../../../../components/user-dashboard-component/pharmacies/edit-pharmacy-form/edit-pharmacy-form';
import { NewRequest } from '../new-request/new-request';

@Component({
  selector: 'app-edit-pharmacy',
  imports: [EditPharmacyForm, NewRequest],
  templateUrl: './edit-pharmacy.html',
  styleUrl: './edit-pharmacy.scss',
})
export class EditPharmacy implements OnInit {
  private route = inject(ActivatedRoute);
  private pharmacyService = inject(PharmacyService);

  pharmacyId = signal<number | null>(null);
  pharmacyData = signal<PharmacyVTO | null>(null);

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      const id = params.get('id');
      if (id) {
        this.pharmacyId.set(+id);
        this.loadPharmacyData(+id);
      }
    });
  }

  loadPharmacyData(id: number) {
    this.pharmacyService.getPharmacyById(id).subscribe((data) => {
      this.pharmacyData.set(data);
    });
  }
}
